import React from 'react'

import austria from './config/austria'
import germany from './config/germany'
import norway from './config/norway'
import switzerland from './config/switzerland'

import staging from './config/staging' // Switzerland
import stagingNorway from './config/staging_norway'
import stagingGermany from './config/staging_germany'
import stagingAustria from './config/staging_austria'

const router = {
  // staging
  'signup-ui.staging.credlock.net': staging,
  'signup-ui-ch.staging.credlock.net': staging,
  'signup-ui-at.staging.credlock.net': stagingAustria,
  'signup-ui-de.staging.credlock.net': stagingGermany,
  'signup-ui-no-legacy.staging.credlock.net': stagingNorway,
  'signup-ui-at-legacy.staging.credlock.net': stagingAustria,

  // prod
  'signup-ui.production.credlock.net': austria,

  'signup.evofitness.no': norway,
  'signup.evofitness.at': austria,
  'signup.evofitness.ch': switzerland,
  'signup.evofitness.de': germany,

  default: require('./config/default').default
}

// Adds config to props based on provided hostname
const withConfig = (WrappedComponent) => {
  const WithConfig = (props) => {
    const hostname = window.location.hostname
    const config = router[hostname] || router.default
    return <WrappedComponent config={config} {...props} />
  }

  return WithConfig
}

export default withConfig
